export default __webpack_public_path__ + "static/media/element_spec_20.12d0c90d.webp";